import type { ConsentSlice } from '../../shared/state/consent-slice';

export const selectConsentReady = <S extends ConsentSlice>(s: S) => s.consent.ready;
export const selectConsentFramework = <S extends ConsentSlice>(s: S) => s.consent.framework;
export const selectConsentCountry = <S extends ConsentSlice>(s: S) => s.consent.country;
export const selectConsentState = <S extends ConsentSlice>(s: S) => s.consent.state;
export const selectConsentGroups = <S extends ConsentSlice>(s: S) => s.consent.activeGroups;
